<template>
    <div class="content-container">
        <hc-table :data="operationList">
            <hc-table-column label="操作名称" width="200px" prop="name" />
            <hc-table-column label="操作说明" prop="remark" />
            <hc-table-column label="适用场景" prop="scene" />
        </hc-table>
    </div>
</template>
<script>
import { FrontendOperation } from './const'

export default {
    name: 'SysTemOperation',
    data() {
        return {
            operationList: Object.freeze(FrontendOperation),
        }
    },
}
</script>
<style lang="less" scoped>
/deep/ .hc-table {
    .hc-table__row {
        height: 47px;
    }
}
</style>
